<template>
  <div>
    <b class="ml-1">{{ $t('WORKING_VIEWS.BUBBLES_COLORS') }}</b>
    <div v-for="(colorData, colorIndex) in planning.config.colors" :key="colorIndex">
      <div class="d-flex py-2">
        <div v-for="(shadeIndex, tabIndex) in ['', ...Array(colorData.sublabels?.length - 1 || 0).keys()]" :title="colorData.sublabels[tabIndex]"
             :class="`el-color-${colorIndex}-${shadeIndex}`" :style="{ opacity: elementColorConfig(colorIndex, shadeIndex) ? '' : '.2' }" class="views-config-color-square bg-el-color pointer"
             @click="selectElementColor(colorIndex, shadeIndex)">
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .views-config-color-square {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    margin-top: 2px;
    border-radius: 50%;
  }
</style>

<script>
  export default {
    props: {
      planning: { type: Object, required: true },
      configElementsColors: { type: Array, default: () => [] },
    },
    emits: ['update:config-elements-colors'],
    methods: {
      selectColor(colors, colorIndex, shadeIndex) {
        const index = colors.findIndex(x => x.color === colorIndex && x.colorShade === shadeIndex);
        if (index > -1) {
          colors.splice(index, 1); // remove
        } else {
          colors.push({ // add
            color: colorIndex,
            colorShade: shadeIndex,
          });
        }
      },
      selectElementColor(colorIndex, shadeIndex) {
        const configElementsColors = this.configElementsColors.slice();
        this.selectColor(configElementsColors, colorIndex, shadeIndex);
        this.$emit('update:config-elements-colors', configElementsColors);
      },
      elementColorConfig(colorIndex, shadeIndex) {
        return this.configElementsColors.some(x => x.color === colorIndex && x.colorShade === shadeIndex);
      },
    },
  };
</script>
